import React, {useCallback, useEffect} from 'react'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import MemberRepo from '../../../Repo/MemberRepo'
import {useParams} from 'react-router-dom'
import {CommonResponseStatus} from '../../../../Network/CommonResponse'
import {MBMemberError} from '../../../Common/MBMemberError'
import {useMBMemberError} from '../../Hooks/UseMBMemberError'
import {UrlQueryParams, useQuery} from '../../Hooks/UseQuery'

type MembersSignupResultPageProps = {
  navigator: NavigatorForMemberPage
  memberRepo: MemberRepo
}
export const MembersEditContractResultPage: React.VFC<MembersSignupResultPageProps> = (
  {
    navigator,
    memberRepo,
  },
) => {
  const {temporaryEnrollmentId} = useParams<{ temporaryEnrollmentId: string }>()

  const status = useQuery('status')
  if (!status) {
    throw new MBMemberError('SystemError')
  }

  const throwMBMemberError = useMBMemberError()

  const goToEditContractCompletePage = useCallback(async () => {
    try {
      const resultGetEditContractResult =
        await memberRepo.getEditContractResult(temporaryEnrollmentId)

      switch (resultGetEditContractResult.status) {
        case CommonResponseStatus.Ok:
          break
        case CommonResponseStatus.NotFound:
        case CommonResponseStatus.InternalServerError:
          // noinspection ExceptionCaughtLocallyJS
          throw new MBMemberError('ServerError')
        default:
          // noinspection ExceptionCaughtLocallyJS
          throw new MBMemberError('UnknownError')
      }

      if (!resultGetEditContractResult.data?.bucketInfo) {
        // noinspection ExceptionCaughtLocallyJS
        throw new MBMemberError('SystemError')
      }

      navigator.goToEditContractCompletePage(
        {...resultGetEditContractResult.data.bucketInfo},
      )

    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'SystemError'
      throwMBMemberError(errorMessage)
    }

  }, [memberRepo, temporaryEnrollmentId])

  const backToEditContractInputPage = useCallback(async () => {
    try {
      const resultGetEditContractResult =
        await memberRepo.getEditContractResult(temporaryEnrollmentId)

      switch (resultGetEditContractResult.status) {
        case CommonResponseStatus.Ok:
          break
        case CommonResponseStatus.NotFound:
        case CommonResponseStatus.InternalServerError:
          // noinspection ExceptionCaughtLocallyJS
          throw new MBMemberError('ServerError')
        default:
          // noinspection ExceptionCaughtLocallyJS
          throw new MBMemberError('UnknownError')
      }

      if (!resultGetEditContractResult.data || !resultGetEditContractResult.data.bucketInfo) {
        // noinspection ExceptionCaughtLocallyJS
        throw new MBMemberError('SystemError')
      }

      navigator.backToEditContractInputPageCauseMobileCarrierError(
        resultGetEditContractResult.data.bucketInfo,
        {
          term: resultGetEditContractResult.data.term,
          method: resultGetEditContractResult.data.method,
          amount: 0,
          creditCard: resultGetEditContractResult.data.creditCard,
          mobileCarrier: resultGetEditContractResult.data.mobileCarrier,
          convenienceStore: resultGetEditContractResult.data.convenienceStore,
        },
      )

    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : 'SystemError'
      throwMBMemberError(errorMessage)
    }

  }, [memberRepo, temporaryEnrollmentId])

  useEffect(() => {
    switch (status) {
      case UrlQueryParams.status.ok:
        goToEditContractCompletePage()
        break
      case UrlQueryParams.status.canceled:
        backToEditContractInputPage()
        break
      default:
        throw new MBMemberError('SystemError')
    }
  }, [status])

  return null
}
